/*
 Provides Props:
 ------------------------------------
 state.tzOffset  // Number of hours tz is offset from UTC
 state.tzCode    // TZ short-code
 state.Location  // String location name

 Actions:
 --------
 state.setTimezone( inputTimezones ) - Detect user's timezone and match it against inputTimezones for a best match

 Emits:
 --------
 'timezone' - whenever a new timezone is set.

 */

export default function (state/*, widget*/) {

    /** Detects the user's current time-zone offset and short code if possible. */
    function detectTimezone() {
        const d = new Date();
        const s = d.toString();
        const r = {userOffset: -d.getTimezoneOffset() / 60};
        try {
            const ri = s.lastIndexOf(')');
            const li = s.lastIndexOf('(', ri);
            if (-1 >= li || li >= ri || li <= ri - 8) {
                // no parenthesis found
            } else if (r.userTz.charAt(li + 1).match(/[0-9+\-]/)) {
                // ignoring numeric timezone
            } else {
                r.userTz = s.substring(li + 1, ri);
            }
        } catch (e) {
            //window.console.error('Failed to parse timezone from', s);
        }
        return r;
    }

    /** Find the time-zone record matching user's time-zone. */
    function matchByTz(userTz, tzData) {
        if (!userTz) {
            return;
        }
        for (let i = 0; i < tzData.length; i++) {
            if (tzData[i].tz === userTz) {
                return tzData[i];
            }
        }
        //window.console.log('No match on TZ', userTz);
    }

    /** Find the offset in tzData which has the same number of locations above and below it. */
    function middleOffset(tzData) {
        if (tzData.middleOffset !== undefined) {
            return tzData.middleOffset;
        }
        let lc1 = 0;
        for (let i = 0; i < tzData.length; i++) {
            lc1 += (tzData[i].locations || []).length;
        }
        let lc2 = 0;
        for (let i = 0; i < tzData.length; i++) {
            lc2 += (tzData[i].locations || []).length;
            if (lc2 >= lc1 / 2) {
                return (tzData.middleOffset = tzData[i].offset);
            }
        }
    }

    /** Find the time-zone records matching the given offset and merge them. */
    function matchByOffset(offset, tzData) {
        let match = null;
        for (let i = 0; i < tzData.length; i++) {
            if (tzData[i].offset === offset) {
                match = match || {
                        offset: offset,
                        tz: [],
                        locations: []
                    };
                match.tz = match.tz.concat(tzData[i].tz || []);
                match.locations = match.locations.concat(tzData[i].locations || []);
            }
        }
        return match;
    }

    /**
     * Given an optional time-zone code, an offset from GMT and a list of time-zone records,
     * Assign the user the best available time-zone code and offset and possibly location
     * from the given list of time-zone records.
     */
    function assignTimezone(userTz, userOffset, tzData) {
        const match = matchByTz(userTz, tzData) ||
            matchByOffset(userOffset, tzData) ||
            matchByOffset(middleOffset(tzData), tzData);
        //console.log('Best Match', match);
        let tz;
        if (match.tz instanceof Array && match.tz.length === 1) {
            // Exactly one time-zone matches
            tz = match.tz[0];
        } else if (typeof(match.tz) === 'string') {
            tz = match.tz;
        } else {
            tz = 'GMT';
            if (match.offset !== 0) {
                tz += (match.offset > 0 ? '+' : '') + match.offset;
            }
        }
        const assignment = {
            tz,
            offset: match.offset,
            location: match.locations.length === 1 ? match.locations[0] : null,
            locations: match.locations
        };
        //console.log('assignment:', assignment);
        return assignment;
    }

    // ------------------------------------------------

    state.tzOffset;
    state.tzCode;
    state.tzLocation;

    // ------------------------------------------------

    state.setTimezone = function (timezones) {
        const {userTz, userOffset} = detectTimezone();
        const tzData = timezones || [{tz: userTz, offset: userOffset, locations: []}];
        const assigned = assignTimezone(userTz, userOffset, tzData);
        state.tzOffset = assigned.offset;
        state.tzCode = assigned.tz;
        state.tzLocation = assigned.location;
        // MAYBE: only update state.tz and emit event if timezone has changed  ?
        state.emit('timezone');
    };

}
